import { theme } from "@chakra-ui/react"

export default theme
